// pages/im/components/message-emitter/input-message-emitter/input-message-emitter.js

const HTML_TAG_REGEXP = /<(\/*(!--|!DOCTYPE|a|abbr|acronym|address|applet|area|article|aside|audio|b|base|basefont|bdi|bdo|big|blockquote|body|br|button|canvas|caption|center|cite|code|col|colgroup|data|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|head|header|hr|html|i|iframe|img|input|ins|kbd|label|legend|li|link|main|map|mark|meta|meter|nav|noframes|noscript|object|ol|optgroup|option|output|p|param|picture|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|source|span|strike|strong|style|sub|summary|sup|svg|table|tbody|td|template|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video|wbr)( .*)*[/]?)>/im;

/**
 * 通用问诊输入框组件
 * 使用业务场景:
 *    1. 导诊拟人化
 *    2. 问诊im私聊页面
 *    3. 私人医生问诊im
 * 组件向外暴露的事件
 * 1. sendImage 发送图片
 * 2. sendText  发送文本
 * 3. panelreset 面板resize
 *    主要用于重算视图使用
 * 4. inputChange 输入文本发生变化
 */
Component({
    /**
     * 组件的属性列表
     */
    properties: {
        placeholder: {
            type: String,
            value: "请输入您的回复",
            observer: function (placeholder) {
                // Android某些机型为空时不起作用，必须使用空格。
                this.setData({
                    placeholder: placeholder || " "
                });
            }
        },
        bizType: {
            type: String,
            value: ""
        },
        regex: {
            type: String,
            value: ""
        },
        regexToast: {
            type: String,
            value: ""
        },
        voiceStatus: {
            type: Boolean,
            value: true
        },
        imageStatus: {
            type: Boolean,
            value: true
        },
        // 发送按钮是否激活 虫洞case使用 若输入框内容不为空或者isSendBtnActive为true则发送按钮常亮
        isSendBtnActive: {
            type: Boolean,
            value: false
        }
    },

    pageLifetimes: {
      show: function() {
        // 修复安卓机器，在IM中点击通卡跳转后，返回后输入框被弹起，但是键盘并未展示
        setTimeout(() => {
          this.setData({
            isShowed: true
          });          
        }, 500);

      },
      hide: function() {
        this.setData({
          isShowed: false
        });
      }
    },

    /**
     * 组件的初始数据
     */
    data: {
        msgText: "",
        msgTextShadow: "",
        isRecordPanelShow: false,
        isImagePanelShow: false,
        resetAllTypes: false,
        isIos:
            wx
                .getSystemInfoSync()
                .system.toLowerCase()
                .indexOf("ios") >= 0,
        isShowed: true
    },

    ready: function () {
        this.cursor = 0;
        this.triggerEvent("panelreset", {}, {
            bubbles: true,
            composed: true
        });
    },

    detached: function () {
        setTimeout(() => {
            this.triggerEvent("panelreset", {}, {
                bubbles: true,
                composed: true
            });
        }, 0);
    },

    /**
     * 组件的方法列表
     */
    methods: {
        /**
         * 存储输入框的值
         */
        bindKeyInput: function (e) {
            this.cursor = e.detail.cursor;
            if (!e.detail.value) {
                this.setData({
                    msgTextShadow: ""
                });
                this.triggerEvent("inputChange", "");
                return;
            }
            let data = e.detail.value.trim();
            // 最多输入150个字符
            if (data.length > 150) {
                data = data.substr(0, 150);
            }
            this.setData({
                msgTextShadow: data
            });
            this.triggerEvent("inputChange", data);
        },
        /**
         * 发送相册获取的图片
         */
        getAlbumPic: function (e) {
            this.triggerEvent("sendImage", e.detail);
        },
        /**
         * 获取相机获取的图片
         */
        getCameraPic: function (e) {
            this.triggerEvent("sendImage", e.detail);
        },
        /**
         * 发送消息
         */
        handleSendText: function () {
            const {
                regex,
                regexToast,
                msgTextShadow,
                isSendBtnActive
            } = this.data;
            // 输入框内容为空或按钮非激活
            if (!msgTextShadow && !isSendBtnActive) return;
            if (HTML_TAG_REGEXP.test(this.data.msgTextShadow)) {
                wx.showToast({
                    title: "内容包含不合法字符",
                    icon: "none",
                    duration: 2000
                });
                return;
            }
            // 基于正则check 内容合法性
            if (regex) {
                const regexIns = new RegExp(regex);
                if (!regexIns.test(msgTextShadow)) {
                    wx.showToast({
                        title: regexToast,
                        icon: "none",
                        duration: 2000
                    });
                    return;
                }
            }
            const textToSend = this.data.msgTextShadow;
            // 清空输入框
            this.triggerEvent("panelreset", {}, {
                bubbles: true,
                composed: true
            });

            this.setData({
                msgText: "",
                msgTextShadow: ""
            });
            // 添加延迟 使blur之后触发发送动作
            setTimeout(() => {
                this.triggerEvent("sendText", textToSend);
            }, 200);
        },
        /**
         * 面板聚焦 可以获取键盘高度
         */
        handlePanelFocus: function (e) {
            if (!this.data.isShowed) {
              return;
            }
            this.isFocus = true;
            this.keyBoardHeight = e && e.detail && e.detail.height;
            this.setData(
                {
                    isRecordPanelShow: false,
                    resetAllTypes: true
                },
                () => {
                    this.triggerEvent("panelreset", e.detail, {
                        bubbles: true,
                        composed: true
                    });
                }
            );
        },
        /**
         * 面板大小变化
         */
        handlePanelReset: function (e) {
            if (e.detail.cursor) {
                // 纪录光标的位置
                this.cursor = e.detail.cursor;
            }
            this.isFocus = false;
            this.setData(
                {
                    resetAllTypes: false
                },
                () => {
                    this.triggerEvent("panelreset", {}, {
                        bubbles: true,
                        composed: true
                    });
                }
            );
        },
        /**
         * 文本框大小变化
         */
        handleLineChange: function (e) {
            const extraParam = this.isFocus
                ? { height: this.keyBoardHeight }
                : {};

            this.triggerEvent("panelreset", extraParam, {
                bubbles: true,
                composed: true
            });
        },

        /**
         * 开启或者关闭录音面板
         */
        activeRecordPanel: function (e) {
            this.setData(
                {
                    isRecordPanelShow: e.detail,
                    resetAllTypes: !e.detail
                },
                () => {
                    this.triggerEvent("panelreset", {}, {
                        bubbles: true,
                        composed: true
                    });
                }
            );
        },
        /**
         * 开启或者关闭照片面板
         */
        activeImagePanel: function (e) {
            this.setData(
                {
                    isRecordPanelShow: false,
                    resetAllTypes: !e.detail,
                    isImagePanelShow: e.detail
                },
                () => {
                    this.triggerEvent("panelreset", {}, {
                        bubbles: true,
                        composed: true
                    });
                }
            );
        }
    }
});
